import ControllerIcon from './component'

export default ControllerIcon
